import { Severity } from "@cayo/shared/api/types/cayo-graph";
import { appEvents } from "@cayo/shared/components/App/appEvents";

export const showMessage = (msg: string, severity?: Severity | undefined) => {
  appEvents.trigger({ showMessage: { text: msg, severity: severity || "informational" } });
};
